/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'underscore',
	'../../../../lib/@waca/core-client/js/core-client/ui/core/Class'
],
function(_, Class) {
	'use strict';

	var IndentedListControl = Class.extend ({
		domNode: null,

		init: function() {
			_.extend(this, arguments[0]);
		}
	});

	return IndentedListControl;
});
